var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginUnique',_vm._b({attrs:{"campaign":_vm.campaign}},'LoginUnique',_vm.$props,false))}
var staticRenderFns = []
export { render, staticRenderFns }